import { computed, inject, Injectable, Signal } from '@angular/core';
import { Nullable } from '@ps/utils';
import {
  Company,
  CompanyDetail,
  CompanyFormMode,
  CompanyOperatorUser,
  Currency,
  NetsuiteCompanyData,
} from '../models/company.model';
import { CompanyListSelectorsFacade } from './company-list.selectors.facade';
import { CompanyDetailSelectorsFacade } from './company-detail.selectors.facade';
import { CompanyReferenceDataSelectorsFacade } from './company-reference-data.selectors.facade';

export interface CompanyViewModel {
  companies: Company[];
  isLoading: boolean;
  currentPage: number;
  pageNumbers: number[];
  mode: CompanyFormMode;
  selectedCompany: Nullable<CompanyDetail>;
  isLoadingDetail: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  currencies: Currency[];
  operatorUsers: CompanyOperatorUser[];
  isFetchingNetsuite: boolean;
  netsuiteCompanyLookupResult: Nullable<NetsuiteCompanyData>;
}

@Injectable({ providedIn: 'root' })
export class CompanySelectorsFacade {
  private readonly _listFacade = inject(CompanyListSelectorsFacade);
  private readonly _detailFacade = inject(CompanyDetailSelectorsFacade);
  private readonly _referenceDataFacade = inject(
    CompanyReferenceDataSelectorsFacade,
  );

  public readonly viewModel: Signal<CompanyViewModel> = computed(() => {
    const totalCount = this._listFacade.totalCount();
    const limit = this._listFacade.limit();
    const pageNumbers = limit
      ? Array.from(
          { length: Math.ceil(totalCount / limit) },
          (_, pageIndex) => pageIndex + 1,
        )
      : [];

    return {
      companies: this._listFacade.companies(),
      isLoading: this._listFacade.isLoading(),
      currentPage: this._listFacade.currentPage(),
      pageNumbers,
      mode: this._detailFacade.mode(),
      selectedCompany: this._detailFacade.selectedCompany(),
      isLoadingDetail: this._detailFacade.isLoadingDetail(),
      isSaving: this._detailFacade.isSaving(),
      isDeleting: this._detailFacade.isDeleting(),
      currencies: this._referenceDataFacade.currencies(),
      operatorUsers: this._referenceDataFacade.operatorUsers(),
      isFetchingNetsuite: false,
      netsuiteCompanyLookupResult: null,
    };
  });
}
